var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576.47 816.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9c51a0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.13,186.69S67,185.74,4.66,418.84c0,0-60.29-280.89,252.71-301.89,0,0,410.58-222.92,300.29,303C557.66,420,482.9,240.43,280.13,186.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.66,418.84,3.16,740a54,54,0,0,0,54,54.22h0V305.36L38.37,287Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M557.66,420l-8.45,345.5a52.63,52.63,0,0,1-52.61,51.34h0l10.57-478.36,35,8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "241.37 124.95 204.18 0 300.37 108.95 241.37 124.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.29 327.37 74.28 417.08 74.28 260.19 46.29 327.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "496.6 309.54 486.25 417.08 514.32 377.41 536.53 309.54 496.6 309.54"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset16);
export default __webpack_public_path__ + "static/media/Asset 16.9e4c8ed8.svg";
export { ForwardRef as ReactComponent };